import React from 'react';
import {Dotarea, Dot} from './style';

export default function DotButton(props) {
    return (
    <Dotarea {...props}>
        <Dot />
    </Dotarea>
    );
}